import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { Button, message, Input, Card, Form, Select, Col, Row, Table } from 'antd';
import { SEARCH_ITEM_COL, TABLE_DATA_DEFAULT } from '@/scripts/config';
// import useSearchList from '@/hooks/useSearchList';
import dayjs from 'dayjs';

const pageKey = 'GoAccountList'; //页面身份
export default function GoAccountList() {
    const [dataSource, setState] = useState([]);

    useEffect(() => {
        ajax.get('account/list?type=go_auth')
            .then((response) => {
                // 添加禁用状态 默认false
                const data = response.map((item) => {
                    item.update_time = item.update_time ? dayjs(item.update_time).format('YYYY-MM-DD HH:mm:ss') : null;
                    return item;
                });

                setState(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            align: 'center',
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: '用户名',
            dataIndex: 'username',
            align: 'center',
            sorter: (a, b) => a['username'].localeCompare(b['username']),
        },
        {
            title: '公司信息',
            dataIndex: 'trading_name',
            align: 'center',
            sorter: (a, b) => a['trading_name'].localeCompare(b['trading_name']),
        },
        {
            title: '客户代码',
            dataIndex: 'customer_code',
            align: 'center',
            sorter: (a, b) => a['customer_code'].localeCompare(b['customer_code']),
        },
        {
            title: '住址',
            dataIndex: 'address',
            align: 'center',
            sorter: (a, b) => a['address'].localeCompare(b['address']),
        },
        {
            title: '更新时间',
            dataIndex: 'update_time',
            align: 'center',
            sorter: (a, b) => +new Date(a.update_time) - +new Date(b.update_time),
        },
    ];

    return (
        <div className="list">
            <PageHeader title="go账号列表" sticky></PageHeader>
            {/* <Card className="ax-table-card">{renderTable()}</Card> */}
            <Table className="List" rowKey={(record) => record.id} pagination={false} dataSource={dataSource} columns={columns} />
        </div>
    );
}
